/**
 * API Configuration Module
 *
 * Provides centralized API URL management for different deployment environments.
 * The API URL is determined at BUILD TIME via REACT_APP_API_URL environment variable.
 *
 * Usage:
 *   import { getApiUrl } from '../config/api';
 *   fetch(getApiUrl('/api/TitelinePlod/GetStagingPlodsByAid?aid=123'))
 *
 * Note: endpoint parameter MUST start with "/" (e.g., "/api/...")
 */

const API_BASE_URL = (process.env.REACT_APP_API_URL || '')
  .trim()
  .replace(/\/+$/, '') ||
  'https://dors-backend-api-gbc5cudcgebde9av.australiaeast-01.azurewebsites.net';

/**
 * Constructs full API URL by combining base URL with endpoint path
 * @param endpoint - API endpoint path (must start with "/")
 * @returns Full API URL
 * @example getApiUrl('/api/TitelinePlod/GetStagingPlodsByAid?aid=123')
 */
export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};

// Development debugging aid - log configured API URL on startup
if (process.env.NODE_ENV !== 'production') {
  console.log('[API Config] Base URL:', API_BASE_URL);
}
